import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(whithRootLayout)/productDetails/[productId]/ProductClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/book-copy.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/calendar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/circle-check-big.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/eye.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/files.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/film.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/hard-drive-download.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/heart.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/library-big.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/message-circle-more.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/percent.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/shapes.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/star.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/tv-minimal-play.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lucideIcons/user.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cards/AddToCart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/productDetails/Comments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/productDetails/ContentSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/productDetails/items.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/productDetails/LazyVideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/productDetails/ScrollSpyTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/productDetails/UserViewTrackerClient.tsx");
